var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 2.66634C5.05513 2.66634 2.66732 5.05416 2.66732 7.99967C2.66732 10.9452 5.05513 13.333 8.00065 13.333C10.9462 13.333 13.334 10.9452 13.334 7.99967C13.334 5.05416 10.9462 2.66634 8.00065 2.66634ZM1.33398 7.99967C1.33398 4.31778 4.31875 1.33301 8.00065 1.33301C11.6825 1.33301 14.6673 4.31778 14.6673 7.99967C14.6673 11.6816 11.6825 14.6663 8.00065 14.6663C4.31875 14.6663 1.33398 11.6816 1.33398 7.99967Z",
    fill: "#7DCC18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4951 8.10424C11.4951 8.47243 11.1966 8.77091 10.8284 8.77091L7.72386 8.77091C7.35567 8.77091 7.05719 8.47243 7.05719 8.10424L7.05719 5.55196C7.05719 5.18377 7.35567 4.88529 7.72386 4.88529C8.09205 4.88529 8.39052 5.18377 8.39052 5.55196L8.39052 7.43758L10.8284 7.43758C11.1966 7.43758 11.4951 7.73605 11.4951 8.10424Z",
    fill: "#7DCC18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenClock);
export default __webpack_public_path__ + "static/media/green-clock.b7336a17220a6a24d23ade3a23dd0f6f.svg";
export { ForwardRef as ReactComponent };